import {
  Button,
  Card,
  Flex,
  Image,
  Markdown,
  useUiKitComponents,
} from "@qws-org/ui-kit";
import type { FC } from "react";

import type { CardGalleryCardGalleryItems } from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";

import type { CardGalleryProps } from "../CardGallery";

export type ColumnCardProps = Omit<CardGalleryProps, "data"> & {
  card?: CardGalleryCardGalleryItems;
};

export const ColumnCard: FC<ColumnCardProps> = (props) => {
  const {
    card: data,
    getImageUrl,
    getUrl,
    isControlInactive,
    onCallAction,
  } = props;
  const { Link } = useUiKitComponents();
  const controlAction = data?.card_gallery_items_id?.button_action;
  const isInactive = controlAction ? isControlInactive(controlAction) : true;
  const action = data?.card_gallery_items_id?.button_action?.action?.[0];
  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }
  const handlePressButton = (): void => {
    if (controlAction) {
      onCallAction(controlAction);
    }
  };
  return (
    <Card variant="primary">
      <Flex
        flexDirection="column"
        d={{ flexDirection: "row", width: "100%" }}
        md={{ maxWidth: 1240 }}
        maxWidth={400}
        gap={10}
      >
        <Link href={href}>
          <Image
            value={getImageUrl(data?.card_gallery_items_id?.image?.id ?? "", {
              format: "webp",
              height: 250,
            })}
            dValue={getImageUrl(data?.card_gallery_items_id?.image?.id ?? "", {
              format: "webp",
              height: 310,
            })}
            border={{ radius: "8px" }}
            height="100%"
            display="flex"
            className="overflow-hidden object-cover"
          />
        </Link>

        <Flex
          className="flex-grow  "
          flexDirection="column"
          justify="space-between"
          md={{ p: { px: 32 } }}
          height="100%"
        >
          <Markdown p={{ pt: 32 }}>
            {data?.card_gallery_items_id?.text ?? ""}
          </Markdown>

          {!isInactive && (
            <Button
              href={href}
              size="small"
              fontWeight="mobile.bold"
              onPress={handlePressButton}
              p={{ py: 12, px: 24 }}
              m={{ my: 24 }}
              d={{ m: { my: 40 }, p: { px: 24, py: 12 } }}
              minWidth="fit-content"
              maxWidth="max-content"
              whiteSpace="pre-wrap"
            >
              {data?.card_gallery_items_id?.button_text}
            </Button>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};
